<app-header text='default'></app-header>

<div id="readspeaker_button_1" class="rs_skip rsbtn rs_preserve" *ngIf="env.readspeaker.enabled">
  <a rel="nofollow" class="rsbtn_play" accesskey="L" i18n-title="@@readSpeakerDescription" title="Listen to this page using ReadSpeaker webReader" [attr.href]="getReadSpeakerURL('content')">
      <span class="rsbtn_left rsimg rspart"><span class="rsbtn_text"><span i18n="@@readSpeakerListen">Listen</span></span></span>
      <span class="rsbtn_right rsimg rsplay rspart"></span>
  </a>
</div>

<div id="content">
  <div class="intro">
      <div class="heading">
        <img [src]="getPath('arrows.png')" alt="arrows">
        {{ LEARNING_PATHWAY_HEADER }}
      </div>
      <div class="text interest"><b>{{interest.text}}</b></div>
      <!--
      <div class="message container text" *ngFor='let text of texts.learningPathwayDescription'>
        {{ text }}
      </div>
      -->
    </div>
  <div id="header">
    
    <div class="description" i18n="">Please, choose your location to see the learning opportunities near you</div>
    <form [formGroup]="locationForm">
      <select class="browser-default custom-select" (change)='setRegion($event.target.value)' formControlName="locationControl">
        <option selected i18n="">Choose your area</option>
        <option value='all' i18n="">Show all</option>
        <option *ngFor='let region of REGIONS' value='{{ region }}'>{{ region }}</option>
      </select>
    </form>
    <hr>
  </div>
  <div class="learning-oportunities" *ngIf="getCourses('brush_up').length > 0 || getCourses('develop').length > 0">
    <div class="brush-up" *ngIf="getCourses('brush_up').length > 0">
      <div class="heading" i18n="@@brushUp">Brush up</div>
      <app-course
        *ngFor="let course of getCourses('brush_up')"
        [course]=course
        colour='green'
        from='localization'
        [results]='results'
        class="course"
      ></app-course>
    </div>
    <div class="develop" *ngIf="getCourses('develop').length > 0">
      <div class="heading" i18n="@@furtherDevelop">Further develop</div>
      <app-course
        *ngFor="let course of getCourses('develop')"
        [course]=course
        colour='blue'
        from='localization'
        [results]='results'
        class="course"
      ></app-course>
    </div>
  </div>
</div>

<div class="footer">
  <app-navigate-button
    i18n-text
    text='Back to results'
    destination='results'></app-navigate-button>
</div>